/**
 * Классификация атрибутов слоев по категориям
 */

export interface LayerAttributeCategory {
  id: string;
  name: string;
  nameEn: string;
  attributes: string[];
}

export const LAYER_ATTRIBUTE_CATEGORIES: LayerAttributeCategory[] = [
  {
    id: 'geometry',
    name: 'Geometry and Structure',
    nameEn: 'Geometry and Structure',
    attributes: [
      'Absolute top mark',
      'Oil and gas area',
      'Heterogeneity',
      'Absolute GOC mark',
      'Absolute GWC mark',
      'Absolute OWC mark',
    ],
  },
  {
    id: 'pvt',
    name: 'PVT Properties',
    nameEn: 'PVT Properties',
    attributes: [
      'Oil density at reservoir conditions',
      'Oil density at surface conditions',
      'Oil viscosity at reservoir conditions',
      'Oil formation volume factor',
      'Gas density at reservoir conditions',
      'Gas viscosity at reservoir conditions',
      'Condensate density at standard conditions',
      'Condensate viscosity at standard conditions',
      'Water density at surface conditions',
      'Water viscosity at reservoir conditions',
      'Condensation onset pressure',
      'Gas saturation pressure of oil',
    ],
  },
  {
    id: 'saturation',
    name: 'Saturation',
    nameEn: 'Saturation',
    attributes: [
      'Average effective oil saturation',
      'Average effective gas saturation',
      'Average effective water saturation',
      'Oil saturation coefficient',
      'Gas saturation coefficient',
    ],
  },
  {
    id: 'petrophysics',
    name: 'Petrophysical Properties and Reservoir Type',
    nameEn: 'Petrophysical Properties and Reservoir Type',
    attributes: [
      'Porosity coefficient',
      'Permeability',
      'Sandiness coefficient',
      'Productivity coefficient',
    ],
  },
  {
    id: 'composition',
    name: 'Fluid Composition',
    nameEn: 'Fluid Composition',
    attributes: [
      'Sulfur content in oil',
      'Paraffin content in oil',
      'Hydrogen sulfide content',
      'Gas content',
    ],
  },
  {
    id: 'reservoir_conditions',
    name: 'Reservoir Conditions',
    nameEn: 'Reservoir Conditions',
    attributes: [
      'Initial reservoir pressure',
      'Initial reservoir temperature',
    ],
  },
  {
    id: 'displacement',
    name: 'Displacement Coefficients',
    nameEn: 'Displacement Coefficients',
    attributes: [
      'Displacement coefficient',
      'Displacement coefficient (by gas)',
    ],
  },
];

export type LayerPropertiesViewMode = 'light' | 'pro';

/** Attributes shown in Light mode (visual filter only; all values still saved). */
export const LIGHT_MODE_ATTRIBUTE_NAMES: readonly string[] = [
  'Porosity coefficient',
  'Permeability',
  'Productivity coefficient',
  'Absolute top mark',
  'Average effective water saturation',
  'Average effective oil saturation',
  'Initial reservoir pressure',
];

export function isLightModeAttribute(attributeName: string): boolean {
  return LIGHT_MODE_ATTRIBUTE_NAMES.includes(attributeName);
}

/**
 * Получить категорию для атрибута
 */
export function getAttributeCategory(attributeName: string): LayerAttributeCategory | undefined {
  return LAYER_ATTRIBUTE_CATEGORIES.find(category =>
    category.attributes.includes(attributeName)
  );
}

/**
 * Группировать атрибуты по категориям
 */
export function groupAttributesByCategory(attributeNames: string[]): Map<string, string[]> {
  const grouped = new Map<string, string[]>();

  LAYER_ATTRIBUTE_CATEGORIES.forEach(category => {
    const categoryAttributes = attributeNames.filter(name =>
      category.attributes.includes(name)
    );
    if (categoryAttributes.length > 0) {
      grouped.set(category.id, categoryAttributes);
    }
  });

  return grouped;
}
